import { render } from "./Symbol.vue?vue&type=template&id=79edbd5e"
import script from "./Symbol.vue?vue&type=script&lang=ts"
export * from "./Symbol.vue?vue&type=script&lang=ts"
script.render = render

export default script